import { Alert } from "@mui/material";
import * as React from "react";
import { useParams } from "react-router-dom";
import { HangarsStateContainer } from "../../containers/HangarsStateContainer";
import { RampsStateContainer } from "../../containers/RampsStateContainer";
import { RampStateContainer } from "../../containers/RampStateContainer";
import { TowingEquipmentContainer } from "../../containers/TowingEquipmentContainer";
// import { TestRamp } from "./TestRamp"; // Removed to reduce bundle size

type Props = {
  rampId?: string;
  isReference?: boolean;
};

export const RampOptimization: React.FC<Props> = ({
  rampId,
  isReference,
  ...props
}) => {
  const { id: rampIdFromRoute } = useParams();
  const TEST_RAMP_ID = '3540d501-1237-4364-9e45-475e849b8b67';

  return (
    // RampsStateContainer and HangarsStateContainer might seem weird. it's for the selection menus
    <RampsStateContainer isReference={isReference ?? false}>
      <HangarsStateContainer isReference={isReference ?? false}>
        <RampStateContainer
          initialState={{
            ramp_id: rampId ?? rampIdFromRoute ?? TEST_RAMP_ID,
            isReference: isReference ?? false,
          }}
        >
          <TowingEquipmentContainer>
            {isReference && (
              <Alert severity="warning">
                This is your Tie Town Tenant Reference ramp. It only shows your
                tie down tenants and is distinct from your active Current Ramp.
              </Alert>
            )}
            {/* <TestRamp /> */}
            <div>Ramp Optimization Component (TestRamp disabled to reduce bundle size)</div>
          </TowingEquipmentContainer>
        </RampStateContainer>
      </HangarsStateContainer>
    </RampsStateContainer>
  );
};
